require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./effect-of-trees-on-crime-in-portland.json") })
        }
      }, "path---effect-of-trees-on-crime-in-portland");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---effect-of-trees-on-crime-in-portland!./.cache/json/effect-of-trees-on-crime-in-portland.json
// module id = 887
// module chunks = 231608221292675